import {createReducer, on} from "@ngrx/store";
import * as messageCountActions from './message-count.actions';
import {MessageCount} from "../../models/MessageCount";
export const MessageCountFeatureKey = 'messageCount';
export const MessageCountInitialState: MessageCount[] = [];
export const MessageCountReducer = createReducer<MessageCount[]>(
  MessageCountInitialState,
  on(messageCountActions.update, (_state, { messageCount }) => messageCount),
);
